import { Flex, Text } from '@chakra-ui/react';
import { InfoIcon } from 'ui-components/dist/InfoIcon';

export const ContentSearchPickerModalLimit: React.FC = () => {
  return (
    <Flex
      flexWrap="wrap"
      alignItems="center"
      backgroundColor="primary.50"
      borderRadius="lg"
      marginTop={6}
      padding={4}
    >
      <InfoIcon color="primary.700" boxSize={4} marginRight={3} />
      <Text color="primary.700" fontSize="lg">
        You have reached the maximum number of content that can be added, to add
        other content you must delete some you have already chosen
      </Text>
    </Flex>
  );
};
